<template>
<div class="chapter">
<div class="inner_page">
<p class="ChapTitle"><a id="HLD6"></a>Forest Park</p>
<p class="mhead">Fabric Requirements and Cutting</p>
<p class="fig"><img alt="" src="images/pg11a.jpg"/></p>
<p class="fig"><img alt="" src="images/pg11.jpg"/></p>
<p class="fig"><img alt="" src="images/pg11b.jpg"/></p>
<p class="nhead">NOTE</p>
<p class="ntxt">Most of the pieces in this block are cut using templates from <span href="#/91_source#pg_193" title="Link target outside of Sample">Pattern 1</span>. The dimensions listed in the chart under “Size to Cut” represent the amount of fabric required for each piece. More fabric may be required for <span href="#/89_chapter85#HLD99" title="Link target outside of Sample">shortcut piecing</span> or <span href="#/89_chapter85#HLD102" title="Link target outside of Sample">fussy cutting</span>.</p>
<p class="ntxt">To make a template from a pattern, refer to <span href="#/89_chapter85#HLD101" title="Link target outside of Sample">Making and Using Freezer-Paper Templates</span>. When cutting your fabric, remember to add seam allowances and mark points for matching seams.</p>
<p class="ph1">Make the Block</p>
<p class="ph2">Make the Contrasting Triangle Unit</p>
<p class="txt">Sew piece B1 and piece B2 to a piece A. The unit will now be 3½˝ × 4½˝. <i>figure a</i></p>
<p class="fig"><img alt="" src="images/pg12.jpg"/></p>
<p class="ph2">Make the Triangle Units</p>
<p class="nl"><b>1.</b> Sew a piece C1 and a piece C2 to a piece A. <i>figure b</i></p>
<p class="fig"><img alt="" src="images/pg12a.jpg"/></p>
<p class="nl"><b>2.</b> Repeat Step 1 to create a total of 3 triangle units AC, each 3½˝ × 4½˝.</p>
<p class="ph2">Finish the Block</p>
<p class="nl"><b>1.</b> Arrange the 4 triangle units in 2 rows, placing the contrasting triangle unit at the top left. Sew the units in each row together. Then sew the 2 rows together.</p>
<p class="nl"><b>2.</b> Sew piece D to the left side of the block. <i>figure c</i></p>
<p class="fig"><img alt="" src="images/pg12b.jpg"/></p>
<p class="ph2">ALTERNATE IDEAS</p>
<p class="fig"><img alt="" src="images/pg12d.jpg"/></p>
<p class="fig"><img alt="" src="images/pg12c.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_chapter04.vue?6d73d42f